import React, { useState } from "react";

export default function GeolocationInput({ value, onChange }) {
  const [lat, setLat] = useState(value?.latitude || "");
  const [lng, setLng] = useState(value?.longitude || "");
  const [acc, setAcc] = useState(value?.accuracy || "");

  const updateParent = (newLat, newLng, newAcc) => {
    onChange({
      latitude: newLat,
      longitude: newLng,
      accuracy: newAcc,
    });
  };

  const captureLocation = () => {
    if (!navigator.geolocation) {
      alert("La geolocalización no es soportada.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const latitude = pos.coords.latitude;
        const longitude = pos.coords.longitude;
        const accuracy = pos.coords.accuracy;

        setLat(latitude);
        setLng(longitude);
        setAcc(accuracy);
        updateParent(latitude, longitude, accuracy);
      },
      () => alert("No se pudo obtener la ubicación. Permite el GPS."),
      { enableHighAccuracy: true }
    );
  };

  const openMaps = () => {
    if (!lat || !lng) return alert("No hay ubicación para mostrar.");
    window.open(`https://www.google.com/maps?q=${lat},${lng}`, "_blank");
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm space-y-4">

      {/* 🔘 Botones superiores (estilo PRODSYNC) */}
      <div className="flex flex-wrap gap-3">
        <button
          onClick={captureLocation}
          className="px-4 py-2 bg-brickRed text-white rounded-md hover:bg-brickRedHover transition font-medium"
        >
          📍 Capturar ubicación
        </button>

        <button
          onClick={openMaps}
          disabled={!lat || !lng}
          className={`px-4 py-2 rounded-md font-medium transition ${
            lat && lng
              ? "bg-darkBrown text-white hover:bg-darkBrownHover"
              : "bg-grayNeutral text-gray-500 cursor-not-allowed"
          }`}
        >
          🌍 Ver mapa
        </button>
      </div>

      {/* 🧩 Inputs alineados en una sola línea */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

        {/* Latitud */}
        <div>
          <label className="text-xs font-semibold text-gray-600 mb-1 block">
            Latitud
          </label>
          <input
            type="number"
            step="0.000001"
            value={lat}
            onChange={(e) => {
              const v = e.target.value;
              setLat(v);
              updateParent(parseFloat(v), lng, acc);
            }}
            className="border w-full rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brickRed"
          />
        </div>

        {/* Longitud */}
        <div>
          <label className="text-xs font-semibold text-gray-600 mb-1 block">
            Longitud
          </label>
          <input
            type="number"
            step="0.000001"
            value={lng}
            onChange={(e) => {
              const v = e.target.value;
              setLng(v);
              updateParent(lat, parseFloat(v), acc);
            }}
            className="border w-full rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brickRed"
          />
        </div>

        {/* Precisión */}
        <div>
          <label className="text-xs font-semibold text-gray-600 mb-1 block">
            Precisión (m)
          </label>
          <input
            type="number"
            value={acc}
            onChange={(e) => {
              const v = e.target.value;
              setAcc(v);
              updateParent(lat, lng, parseFloat(v));
            }}
            className="border w-full rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brickRed"
          />
        </div>
      </div>
    </div>
  );
}
